exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-list .add-version-btn[data-v-3117610d] {\n  float: right;\n  margin-top: 9px;\n  margin-bottom: 16px;\n}\n[data-v-3117610d] .el-tabs__item {\n  padding: 0 50px !important;\n}\n[data-v-3117610d] .fade-enter-active,[data-v-3117610d] .fade-leave-active {\n  -webkit-transition: opacity 0.5s;\n  transition: opacity 0.5s;\n}\n[data-v-3117610d] .fade-enter,[data-v-3117610d].fade-leave-to {\n  opacity: 0;\n}", ""]);

// exports
